export default __webpack_public_path__ + "static/media/yelp-logo.d5dfb233.svg";